// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","887":"Detail"}[chunkId] || chunkId) + "." + {"74":"bfc03592","443":"9feaf0a9","887":"c60a0716"}[chunkId] + ".js";
};